export default "__VITE_ASSET__C6KQjsd8__"